import React from "react";
import { useSelector } from "react-redux";
import { Space, Tag } from "antd";
import { CheckCircleTwoTone, CloseCircleOutlined } from "@ant-design/icons";
import { supportOldUserResponseIdSelector, userResponsesSelector } from "../FirestoreInteractions/selector";
import { getRecursiveSegments } from "views/Experiences/ExperienceHelperMethods";
import { getLabelFromIndexPath } from "lib/utils/helperMethods";

const QuestionStatusTagRender = (props) => {
  const {questionsStatus, experienceId, userId, responseIdentifier, segmentId, tagText} = props
  let userResponse = useSelector(userResponsesSelector(experienceId, userId, responseIdentifier))
  console.log("QuestionStatusTagRender ==>", questionsStatus, experienceId, userId, responseIdentifier, segmentId, tagText, userResponse)
  let qAttemptStatus = {}
  if (questionsStatus) {
    qAttemptStatus = questionsStatus && questionsStatus.find((q) => q.segment_id == segmentId);
  } else {
    qAttemptStatus = userResponse.attempt_status
  }
  let finalRender = []
  let innerRender, color, icon;

  if (qAttemptStatus && qAttemptStatus.attempted) {
    innerRender = <CheckCircleTwoTone />;
    color = "processing";
    icon = ""; // no need i think
  } else {
    innerRender = <CloseCircleOutlined />;
    color = "";
    icon = "";
  }

  // finalRender.push(<Tooltip title={`${i+1}.${j+1}`}>{innerRender}</Tooltip>)
  finalRender.push(
    <Tag key={`question-attempt-status-${segmentId}`} icon={icon} color={color} style={{ cursor: "default" }}>{tagText}</Tag>
  );

  return finalRender
}

const AttemptStatus = (props) => {
  const { experienceId, userId, totalQuestions, questionsStatus, userResponses, experienceTopics, wide = false } = props;

  const supportOldUserResponseId = useSelector(supportOldUserResponseIdSelector());
  console.log("Attempt status props ==>", props)
  let finalRender = [];
  const indexPath = []
  // TODO: sort item.questions_status by qNo first and loop thru question count of exp, match with qNo in attempt_status array. PROB - qNo is not overall - only per topic.... need to change while saving
  // for (let qNo = 1; qNo <= totalQuestions; qNo++) {
  //   let q = item.questions_status.find((it) => it.qNo == qNo)
  //   if(q && q.attempted){
  //     finalRender.push(<Badge count={10} />)
  //   }else{
  //     finalRender.push(<Badge count={1} />)
  //   }
  // }

  if (experienceTopics) {
    experienceTopics.forEach((topic, i) => {
      let options = {
        segment_type: "question",
        segments: topic.children,
      }
      const callback = (data, segment, index, level) => {
        let questionType = segment.question_segment_attributes.question_type
        // let qindex = [i, j]
        indexPath.splice(level + 1)
        indexPath[level + 1] = index
        // console.log("2 index path ==>", level, indexPath, titleToRender)
        if (questionType == "group") {
          getRecursiveSegments("", segment, index, level + 1, indexPath, options, callback)
        } else {
          let innerTagRender =
          <QuestionStatusTagRender
            segmentId={segment.id}
            tagText={getLabelFromIndexPath(indexPath)}
            experienceId={experienceId}
            userId={userId}
            responseIdentifier={
              supportOldUserResponseId
                ? `eId${experienceId}_uId${userId}_qId${segment.question_segment_attributes.id}_sId${segment.id}`
                : `eId${experienceId}_uId${userId}_sId${segment.id}`}
            questionsStatus={questionsStatus}>
          </QuestionStatusTagRender>
        finalRender.push(innerTagRender)
        } 
      }
      getRecursiveSegments("", topic.segment, i, 0, indexPath, options, callback)
    })
  }

  // if (experienceTopics) {
  //   experienceTopics.forEach((topic, i) => {
  //     let l1_questions = topic.children.filter(
  //       (segment) => segment.segment_type == "question" && segment.parent_id === parseInt(topic.segment.id)
  //     );
  //     l1_questions.forEach((segment, j) => {
  //       let questionType = segment.question_segment_attributes.question_type
  //       if(questionType === "group"){
  //         let l2_questions = topic.children.filter(
  //           (s1) => s1.segment_type == "question" && s1.parent_id === parseInt(segment.id)
  //         ); 
  //         l2_questions.forEach((segment, k) => {
  //           let questionType = segment.question_segment_attributes.question_type
  //           if(questionType === "group"){
  //             let l3_questions = topic.children.filter(
  //               (s2) => s2.segment_type == "question" && s2.parent_id === parseInt(segment.id)
  //             ); 
  //             l3_questions.forEach((segment, l) => {
  //               let questionType = segment.question_segment_attributes.question_type
  //               if(questionType === "group"){
  //                 // let l3_questions = segment.children.filter(
  //                 //   (segment) => segment.segment_type == "question" && segment.parent_id === parseInt(segment.id)
  //                 // ); 
                  
  //               }else{
  //                 // let innerTagRender = getTagRender(segment.id, `${i + 1}.${j + 1}.${k + 1}.${l + 1}`)
  //                 let innerTagRender = 
  //                   <QuestionStatusTagRender 
  //                     segmentId={segment.id}
  //                     tagText={`${i + 1}.${j + 1}.${k + 1}.${l + 1}`} 
  //                     experienceId={experienceId}
  //                     userId={userId}
  //                     responseIdentifier={
  //                       supportOldUserResponseId 
  //                       ? `eId${experienceId}_uId${userId}_qId${segment.question_segment_attributes.id}_sId${segment.id}`
  //                       : `eId${experienceId}_uId${userId}_sId${segment.id}`}
  //                     questionsStatus={questionsStatus}>
  //                   </QuestionStatusTagRender>
  //                 finalRender.push(innerTagRender)
  //               }
  //             })
  //           }else{
  //             // let innerTagRender = getTagRender(segment.id, `${i + 1}.${j + 1}.${k + 1}`)
  //             let innerTagRender = 
  //               <QuestionStatusTagRender 
  //                 segmentId={segment.id}
  //                 tagText={`${i + 1}.${j + 1}.${k + 1}`} 
  //                 experienceId={experienceId}
  //                 userId={userId}
  //                 responseIdentifier={
  //                   supportOldUserResponseId 
  //                   ? `eId${experienceId}_uId${userId}_qId${segment.question_segment_attributes.id}_sId${segment.id}`
  //                   : `eId${experienceId}_uId${userId}_sId${segment.id}`}
  //                 questionsStatus={questionsStatus}>
  //               </QuestionStatusTagRender>
  //             finalRender.push(innerTagRender)
  //           }
  //         })
  //       }else{
  //         // let innerTagRender = getTagRender(segment.id, `${i + 1}.${j + 1}`)
  //         let innerTagRender = 
  //           <QuestionStatusTagRender 
  //             segmentId={segment.id}
  //             tagText={`${i + 1}.${j + 1}`} 
  //             experienceId={experienceId}
  //             userId={userId}
  //             responseIdentifier={
  //               supportOldUserResponseId 
  //               ? `eId${experienceId}_uId${userId}_qId${segment.question_segment_attributes.id}_sId${segment.id}`
  //               : `eId${experienceId}_uId${userId}_sId${segment.id}`}
  //             questionsStatus={questionsStatus}>
  //           </QuestionStatusTagRender>
  //         finalRender.push(innerTagRender)
  //       }
  //     });
  //   });
  // }

  // item.questions_status.map((question, i) => {
  //   let itemRender = question.attempted ? <Badge count={1} /> : <Badge count={0} />
  //   finalRender.push(itemRender)
  // })
  return (
    <Space
      wrap={true}
      className={`attempt-status-questions ${wide ? "max-w-600" : "max-w-300"}`}
    >
      {finalRender}
    </Space>
  );
};

export default AttemptStatus;
